import React from "react";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { ScheduleList } from "../components/schedule";
import ManFaceA from "../assets/img/test/1H_7AxP0.jpg";
import ManFaceB from "../assets/img/test/VUMBKh1U.jpg";
import WomanFaceA from "../assets/img/test/NDk2NTAuanBn.jpg";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  icon: {
    color: "#3f3f3f",
    height: 25,
    width: 25,
  },
});

const BoothSchedule = () => {
  const classes = useStyles();
  //本日Boothを利用するUserDataを取得
  //さらにLIVE時間帯で3つに分ける
  //それぞれをpropsでscheduleList渡す
  const dayUserList = [
    {
      uid: "0001",
      username: "渡哲也",
      avater: ManFaceA,
      timezone: "08:15 - 12:00",
    },
    {
      uid: "0002",
      username: "桐谷美玲",
      avater: WomanFaceA,
      timezone: "10:00 - 11:00",
    },
    {
      uid: "0003",
      username: "小林たける",
      avater: ManFaceB,
      timezone: "12:00 - 13:00",
    },
  ];
  const nightUserList = [
    {
      uid: "0004",
      username: "小林たける",
      avater: ManFaceB,
      timezone: "17:00 - 18:00",
    },
    {
      uid: "0005",
      username: "桐谷美玲",
      avater: WomanFaceA,
      timezone: "19:00 - 20:00",
    },
    {
      uid: "0006",
      username: "小林たける",
      avater: ManFaceB,
      timezone: "22:00 - 23:00",
    },
  ];
  const midnightUserList = [
    {
      uid: "0007",
      username: "渡哲也",
      avater: ManFaceA,
      timezone: "3:15 - 3:30",
    },
  ];
  return (
    <div>
      <div className="flex-row--center">
        <ScheduleIcon className={classes.icon} />
        <div className="row-spacer--s" />
        <div className="schedule-title">本日の展示スケジュール</div>
      </div>
      <div className="spacer-box--m"></div>
      <ScheduleList headline="第１部 [ 08:00 - 17:00 ]" userlist={dayUserList} />
      <div className="spacer-box--ss"></div>
      <ScheduleList headline="第２部 [ 17:00 - 24:00 ]" userlist={nightUserList} />
      <div className="spacer-box--ss"></div>
      <ScheduleList headline="第３部 [ 24:00 - 08:00 ]" userlist={midnightUserList} />
    </div>
  );
};

export default BoothSchedule;
